export default __webpack_public_path__ + "static/media/WBE_Seal_REVERSE_CMYK.7d5b1d23.webp";